var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E459B",
    stroke: "#7E459B",
    strokeWidth: 0.5,
    d: "M13.121 25.7c.38.4 1.014.4 1.408 0 .38-.388.38-1.033 0-1.42l-7.137-7.268h19.332c.549-.001 1.276-.446 1.276-1.005 0-.559-.727-1.018-1.276-1.018H7.392l7.137-7.255c.38-.4.38-1.047 0-1.433a.974.974 0 0 0-1.408 0L4.295 15.29a1.003 1.003 0 0 0 0 1.42l8.826 8.99z"
  })));
};
export default SvgArrowLeft;